import { useContext } from 'react';
import CacheContext from '../context/CacheContext';

export const useCachedData = () => {
    const context = useContext(CacheContext);

    if (!context) {
        throw new Error('useCachedData debe usarse dentro de <CacheProvider>');
    }

    return context;
};